import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import { Button } from "@material-ui/core";
import PaynlMerchantSetup from "./PaynlMerchantSetup";

export default function PaynlMerchant(props) {
  const [setupIsOpen, setSetupIsOpen] = useState(false);

  if (props.paymentMethod.paynlMerchant) {
    return (
      <Box>
        Merchant connected: {props.paymentMethod.paynlMerchant.merchantName}
        <Button
          variant={"outlined"}
          color={"secondary"}
          onClick={() => {
            props.updatePaynlMerchant(null);
          }}
        >
          Remove merchant connection
        </Button>
      </Box>
    );
  } else {
    return (
      <Box>
        {!setupIsOpen && (
          <Button
            size={"small"}
            variant={"outlined"}
            color={"primary"}
            onClick={() => {
              setSetupIsOpen(true);
            }}
          >
            Connect Merchant
          </Button>
        )}

        {setupIsOpen && <PaynlMerchantSetup updatePaynlMerchant={props.updatePaynlMerchant} />}
      </Box>
    );
  }
}
